import CloseIcon from '@mui/icons-material/Close';
import { Dialog,DialogContent,DialogTitle } from "@mui/material";
import IconButton from '@mui/material/IconButton';
import { useMutation } from "@tanstack/react-query";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { AiOutlineCheck,AiOutlineClose } from "react-icons/ai";
import { toast } from "react-toastify";
import AttToken from "../../../helpers/attToken";
import { trackEventMatomo } from "../../../helpers/matomo";
import Tickets from "../../../service/Tickets";
import { TicketsType } from "../../../types/notifications/types";
import { ButtonsDiv,MotivoSpan,NameSpan } from "../style/AllNotificationsStyle";

type props = {
  open: boolean,
  setOpen: Function,
  chamados: TicketsType[] | undefined
};

const ticketsService = new Tickets();

export default function RedirectListModal({
  open,
  setOpen,
  chamados

}: props) {
  const [showAccpet, setShowAccept] = useState(true);
  const [showReject, setShowReject] = useState(true);
  const { t } = useTranslation('translation');

  const { mutate } = useMutation({
    mutationKey: ['REDIRECT_TICKEST'],
    mutationFn: async ({ action, chamadoId }: { action: 'rejeita' | 'aceita', chamadoId: string }) => {
      const token = await AttToken();
      if (!token) throw new Error('Token not found');
      const promise = toast.promise(async () => {
        const response = await ticketsService.redirecionaChamado(token, chamadoId, null, null, action);
        if (!response) throw new Error('Error performing action');
        return response;
      },
        {
          pending: `${t('notifications.modals.performingAction')}`,
          success: action === 'aceita' ? `${t('notifications.modals.ticketAccepted')}` : `${t('notifications.modals.ticketRejected')}`,
          error: `${t('notifications.modals.errorPerformingAction')}`,
        }, {
        toastId: 'redirect',
      });
      return promise;
    },
    onSuccess: () => {
      setOpen(false);
      trackEventMatomo('modal redireciona chamado', 'click', 'buttob', 'redireciona');
    }
  });

  return (
    <Dialog
      fullWidth
      maxWidth="md"
      open={open}
      onClose={() => setOpen(false)}
      scroll="paper"
    >
      <DialogTitle>{t('notifications.modals.ticketsRedirected')}</DialogTitle>
      <IconButton
        aria-label="close"
        onClick={() => setOpen(false)}
        sx={(theme) => ({
          position: 'absolute',
          right: 8,
          top: 8,
          color: theme.palette.grey[500],
        })}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent dividers={true}>
        <div className="modal-card-body">
          {chamados && chamados?.map((ticket) => (
            <div style={{
              display: 'flex',
              justifyContent: 'space-around',
              alignItems: 'center',
              backgroundColor: '#f0f0f0',
              border: 'none',
              borderRadius: '0 0 20px 20px',
              margin: '10px',
              flexDirection: 'column',
            }}>
              <NameSpan>{ticket.nome.toLocaleLowerCase()}</NameSpan>
              <div style={{ marginTop: '5px', marginBottom: '10px', width: '90%', wordBreak: 'break-all' }}>
                <MotivoSpan>{t('notifications.modals.reasonForRedirecting')}</MotivoSpan>
                <span style={{ maxWidth: '70%' }}>{ticket.motivoEncaminhamento}</span>
              </div>
              <ButtonsDiv>
                <button
                  className="accept"
                  onMouseEnter={() => setShowReject(false)}
                  onMouseLeave={() => setShowReject(true)}
                  onClick={() => {
                    trackEventMatomo('modal redireciona chamado', 'click', 'buttob', 'redireciona');
                    mutate({ action: 'aceita', chamadoId: ticket?.id });
                  }}
                  style={{ width: showAccpet ? '100%' : '5%' }}
                >
                  <AiOutlineCheck />
                </button>
                <button
                  className="reject"
                  onMouseEnter={() => setShowAccept(false)}
                  onMouseLeave={() => setShowAccept(true)}
                  onClick={() => {
                    trackEventMatomo('modal redireciona chamado', 'click', 'buttob', 'cancela');
                    mutate({ action: 'rejeita', chamadoId: ticket.id });
                  }}
                  style={{ width: showReject ? '100%' : '5%' }}
                >
                  <AiOutlineClose />
                </button>
              </ButtonsDiv>
            </div>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
}
